import { userTrack } from '@/api/product'
import { setPurchaseNum } from '@/api/sucker'
/* 多处使用的东西 */
// 记录用户操作轨迹
/**
 *
 buy_product click_buy 【王宇】点击了【XXXXXXX】产品购买
 product_demo_applay apply_form 【王宇】提交了【XXXXXXX】产品Demo申请
 product_example_applay sample_form 【王宇】提交了【XXXXXXX】产品样品申请
 pdf_share pdf_share 【王宇】完成了【XXXXX】PDF邮件分享
 pdf_copy_download pdf_copy_download 【王宇】完成了【XXXXX】PDF链接复制
 * **/
export const recordUserTrack = function (params) {
    userTrack(params).then(res => {
        console.log(res)
    })
}

export const centrifugeRecord = function (params) { // 离心机的相关记录
    setPurchaseNum(params).then(res => {
        // console.log(res)
    })
}
